import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const AddImplementationStage = createAsyncThunk(
  "ImplementationStages/AddImplementationStage",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_WPB_ImplementationStages/AddImplementationStage",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteImplementationStage = createAsyncThunk(
  "ImplementationStages/DeleteImplementationStage",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_WPB_ImplementationStages/DeleteImplementationStage",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllImplementationStageList = createAsyncThunk(
  "ImplementationStages/GetAllImplementationStage",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_WPB_ImplementationStages/GetAllImplementationStage",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllImplementationStageDrpDownList = createAsyncThunk(
  "ImplementationStages/GetAllImplementationStageDrpDownList",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAlllImplementationStageDropDown",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetLengthImplementationStage = createAsyncThunk(
  "ImplementationStages/GetLengthImplementationStage",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_WPB_ImplementationStages/GetLengthImplementationStage",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EditImplementationStage = createAsyncThunk(
  "ImplementationStages/EditImplementationStage",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_WPB_ImplementationStages/EditImplementationStage",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowImplementationStage = createAsyncThunk(
  "ImplementationStages/GetSpecificRowImplementationStage",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_WPB_ImplementationStages/GetSpecificRowImplementationStage",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const ImplementationStageReducers = createSlice({
  name: "FetchDataJson",
  initialState: {
    AddImplementationStage: {},
    loadingAddImplementationStage: false,
    errorAddImplementationStage: null,

    DeleteImplementationStage: {},
    loadingDeleteImplementationStage: false,
    errorDeleteImplementationStage: null,

    ImplementationStageList: {},
    loadingImplementationStageList: false,
    errorImplementationStageList: null,

    ImplementationStageListDropDown: {},
    loadingImplementationStageListDropDown: false,
    errorImplementationStageListDropDown: null,

    ImplementationStageLength: 0,
    loadingImplementationStageLength: false,
    errorImplementationStageLength: null,

    ImplementationStageEdit: {},
    loadingImplementationStageEdit: false,
    errorImplementationStageEdit: null,

    SpecificRowImplementationStage: {},
    loadingSpecificRowImplementationStage: false,
    errorSpecificRowImplementationStage: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddImplementationStage.pending, (state, action) => {
        state.loadingAddImplementationStage = true;
        state.AddImplementationStage = action.payload;
        state.errorAddImplementationStage = null;
      })
      .addCase(AddImplementationStage.fulfilled, (state, action) => {
        state.loadingAddImplementationStage = false;
        state.AddImplementationStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddImplementationStage.rejected, (state, action) => {
        state.loadingAddImplementationStage = false;
        state.errorAddImplementationStage = action.payload;
      });

    builder
      .addCase(DeleteImplementationStage.pending, (state, action) => {
        state.loadingDeleteImplementationStage = true;
        state.DeleteImplementationStage = action.payload;
        state.errorDeleteImplementationStage = null;
      })
      .addCase(DeleteImplementationStage.fulfilled, (state, action) => {
        state.loadingDeleteImplementationStage = false;
        state.DeleteImplementationStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteImplementationStage.rejected, (state, action) => {
        state.loadingDeleteImplementationStage = false;
        state.errorDeleteImplementationStage = action.payload;
      });

    builder
      .addCase(GetAllImplementationStageList.pending, (state, action) => {
        state.loadingImplementationStageList = true;
        state.ImplementationStageList = action.payload;
        state.errorImplementationStageList = null;
      })
      .addCase(GetAllImplementationStageList.fulfilled, (state, action) => {
        state.loadingImplementationStageList = false;
        state.ImplementationStageList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllImplementationStageList.rejected, (state, action) => {
        state.loadingImplementationStageList = false;
        state.errorImplementationStageList = action.payload;
      });

    builder
      .addCase(
        GetAllImplementationStageDrpDownList.pending,
        (state, action) => {
          state.loadingImplementationStageListDropDown = true;
          state.ImplementationStageListDropDown = action.payload;
          state.errorImplementationStageListDropDown = null;
        }
      )
      .addCase(
        GetAllImplementationStageDrpDownList.fulfilled,
        (state, action) => {
          state.loadingImplementationStageListDropDown = false;
          state.ImplementationStageListDropDown = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetAllImplementationStageDrpDownList.rejected,
        (state, action) => {
          state.loadingImplementationStageListDropDown = false;
          state.errorImplementationStageListDropDown = action.payload;
        }
      );

    builder
      .addCase(GetLengthImplementationStage.pending, (state, action) => {
        state.loadingImplementationStageLength = true;
        state.ImplementationStageLength = action.payload;
        state.errorImplementationStageLength = null;
      })
      .addCase(GetLengthImplementationStage.fulfilled, (state, action) => {
        state.loadingImplementationStageLength = false;
        state.ImplementationStageLength = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetLengthImplementationStage.rejected, (state, action) => {
        state.loadingImplementationStageLength = false;
        state.errorImplementationStageLength = action.payload;
      });


       builder
      .addCase(EditImplementationStage.pending, (state, action) => {
        state.loadingImplementationStageEdit = true;
        state.ImplementationStageEdit = action.payload;
        state.errorImplementationStageEdit = null;
      })
      .addCase(EditImplementationStage.fulfilled, (state, action) => {
        state.loadingImplementationStageEdit = false;
        state.ImplementationStageEdit = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditImplementationStage.rejected, (state, action) => {
        state.loadingImplementationStageEdit = false;
        state.ImplementationStageEdit = action.payload;
      });


      builder
      .addCase(GetSpecificRowImplementationStage.pending, (state, action) => {
        state.loadingSpecificRowImplementationStage = true;
        state.SpecificRowImplementationStage = action.payload;
        state.errorSpecificRowImplementationStage = null;
      })
      .addCase(GetSpecificRowImplementationStage.fulfilled, (state, action) => {
        state.loadingSpecificRowImplementationStage = false;
        state.SpecificRowImplementationStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificRowImplementationStage.rejected, (state, action) => {
        state.loadingSpecificRowImplementationStage = false;
        state.SpecificRowImplementationStage = action.payload;
      });
  },
});

export default ImplementationStageReducers.reducer;
